<template>
  <div class="pricing-sub-and-skill-dive">
    <div class="pricing-sub-and-skill-dive__titles">
      <span class="pricing-sub-and-skill-dive__title">Select Skill Dive focus area(s)</span>
      <span>One focus area included. $99 for each additional focus area.</span>
    </div>
    <div class="pricing-sub-and-skill-dive__skill-areas" v-if="skillDivePlan">
      <div
        class="pricing-sub-and-skill-dive__skill-area-container"
        v-for="(addOn, index) in skillDivePlan.addOns"
        :key="index"
      >
        <span class="pricing-sub-and-skill-dive__skill-area-label">{{ addOn.label }}</span>
        <div @click="selectAddOn(addOn)">
          <CheckBox :cartTheme="true" :isSelected="isSelected(addOn)" />
        </div>
      </div>
    </div>
    <div v-if="displayError" class="pricing-sub-and-skill-dive__error">
      <NotificationIcon class="pricing-sub-and-skill-dive__error--icon" />
      <span class="pricing-sub-and-skill-dive__error--text"> Please choose a focus area.</span>
    </div>
    <div class="pricing-sub-and-skill-dive__text-container">
      <div class="pricing-sub-and-skill-dive__text-container--border"></div>
      <span class="pricing-sub-and-skill-dive__text-container--text">
        Your INE Subscription renews automatically unless canceled before the renewal date. To avoid
        charges, cancel before the scheduled renewal. Your free exam voucher redemption code will be
        delivered via email within 24 hours of completing your purchase.
      </span>
    </div>
  </div>
</template>

<script>
import CheckBox from '@/components/shared/CheckBox.vue'
import NotificationIcon from '@/assets/icons/notification.svg'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PricingListSubAndSkillDive',
  components: {
    CheckBox,
    NotificationIcon,
  },
  data() {
    return {
      defaultLearningArea: undefined,
      displayError: false,
    }
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    skillDivePlan: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      selectedPlan: 'shoppingCart/selectedPlan',
      selectedAddOnsByUser: 'shoppingCart/selectedAddOnsByUser',
    }),
  },
  methods: {
    ...mapActions({
      addAddonsToPlanInCart: 'shoppingCart/addAddonsToPlanInCart',
      removeAddonsFromPlanInCart: 'shoppingCart/removeAddonsFromPlanInCart',
      setselectedAddOnsByUser: 'shoppingCart/setselectedAddOnsByUser',
      priceDetailsUpdate: 'priceDetails/priceDetailsUpdate',
    }),
    addOnAlreadyExist(addOn) {
      return this.selectedPlan?.addOnsOnCart.some(
        existingAddOn => existingAddOn.merchant_id === addOn.merchant_id
      )
    },

    async firstSelection(addOn) {
      if (addOn.merchant_id !== this.defaultLearningArea.merchant_id) {
        await this.removeAddonsFromPlanInCart({
          plan: this.selectedPlan,
          addOn: this.defaultLearningArea,
        })
        await this.addAddonsToPlanInCart({
          plan: this.selectedPlan,
          addOn,
        })
      }
      await this.setselectedAddOnsByUser(true)
      await this.priceDetailsUpdate()
    },

    async selectAddOn(addOn) {
      this.displayError = false
      if (!this.selectedAddOnsByUser) {
        return this.firstSelection(addOn)
      }
      if (this.addOnAlreadyExist(addOn)) {
        await this.removeAddonsFromPlanInCart({
          plan: this.selectedPlan,
          addOn,
        })
      } else {
        await this.addAddonsToPlanInCart({
          plan: this.selectedPlan,
          addOn,
        })
      }

      await this.setselectedAddOnsByUser(true)

      if (this.selectedPlan.addOnsOnCart.length === 0) {
        await this.addAddonsToPlanInCart({
          plan: this.selectedPlan,
          addOn: this.defaultLearningArea,
        })
        await this.setselectedAddOnsByUser(false)
        this.displayError = true
      }

      await this.priceDetailsUpdate()
    },

    isSelected(addOn) {
      if (!this.selectedAddOnsByUser) return false
      return this.addOnAlreadyExist(addOn)
    },
  },
  async created() {
    this.defaultLearningArea = this.selectedPlan?.addOnsOnCart[0]
  },
}
</script>

<style lang="scss" scoped>
.pricing-sub-and-skill-dive {
  margin: 0;
  position: relative;

  @include mobile {
    margin: 10px 0 0 10px;
  }

  &__titles {
    display: flex;
    flex-direction: column;
  }

  &__title {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
  }

  &__text-container {
    display: flex;
    align-items: center;
    gap: 10px;

    &--border {
      height: 56px;
      width: 3px;
      border-left: 3px solid var(--white);
      border-radius: 10px;
    }

    &--text {
      color: var(--dusty-gray);
    }
  }

  &__skill-areas {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    margin-top: 10px;
    margin-bottom: 27px;
    flex-direction: column;
    gap: 10px;

    @include mobile {
      flex-direction: row;
      gap: 20px;
      align-items: flex-start;
    }
  }

  &__skill-area-container {
    display: flex;
    align-items: center;
    gap: 5px;
    justify-content: space-between;
    width: 100%;

    @include mobile {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: auto;
    }
  }
  &__skill-area-label {
    color: var(--light-blue-gray);
    font-size: 12px;
  }
  &__error {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 8px;
    gap: 8px;
    &--text {
      color: var(--red-error);
      font-size: 10px;
    }
    &--icon {
      stroke: var(--red-error);
      width: 14px;
      height: 14px;
    }
  }
}
</style>
